import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {StepTypeInfo} from 'pipelines/hooks/useStepTypeInfosQuery';
import {BenchlingIconName, isValidBenchlingIcon} from 'ui-library/icons/BenchlingIcon';

import {getIconForStepDataKindOrUndefined} from './RawStepDataKindRegistry';

export function getStepTypeIcon(
  stepType: PipelineStepType,
  stepTypeInfos: ReadonlyMap<PipelineStepType, StepTypeInfo>
): BenchlingIconName | null {
  const icon = stepTypeInfos.get(stepType)?.icon;
  return icon != null && isValidBenchlingIcon(icon) ? icon : null;
}

export function getStepTypeIconOrDefault(
  stepType: PipelineStepType,
  stepTypeInfos: ReadonlyMap<PipelineStepType, StepTypeInfo>,
  defaultIcon: BenchlingIconName
): BenchlingIconName {
  return getStepTypeIcon(stepType, stepTypeInfos) ?? defaultIcon;
}

/** Fallback icon for a raw data kind that has no icon registered yet. */
const DEFAULT_STEP_DATA_KIND_ICON: BenchlingIconName = 'table';

export function getIconForStepDataKind(kind: PipelineStepDataKind): BenchlingIconName {
  return getIconForStepDataKindOrUndefined(kind) ?? DEFAULT_STEP_DATA_KIND_ICON;
}
